import axios from '@/plugins/axios'

import { useAuthorizationStore } from '@/store/authorizationStore'

const getWorkspaceId = () => useAuthorizationStore().getWorkspaceSlug

const getPoolsAll = () => axios.get(`${getWorkspaceId()}/number-pools/all`)
const getPoolsForManager = (params) => axios.get(`${getWorkspaceId()}/number-pools/paginated`, { params })
const getPoolsForVendor = (params) => axios.get(`${getWorkspaceId()}/vendor/number-pools/paginated`, { params })

const getAvailableNumbersForPool = (slug) => axios.get(`${getWorkspaceId()}/number-pools/${slug}/available-numbers`)
const createPool = (formData) => axios.post(`${getWorkspaceId()}/number-pools`, formData)
const updatePool = ({ slug, formData }) => axios.patch(`${getWorkspaceId()}/number-pools/${slug}`, formData)
const deletePool = (data) => axios.delete(`${getWorkspaceId()}/number-pools`, { data })
const autoBuyPool = ({ slug, formData }) => axios.patch(`${getWorkspaceId()}/number-pools/${slug}/buy-numbers`, formData)
const detachPool = ({ slug, data }) => axios.delete(`${getWorkspaceId()}/number-pools/${slug}/reset-numbers`, { data })
const getDetailPool = (slug) => axios.get(`${getWorkspaceId()}/number-pools/${slug}`)
const getAvailableTrafficSources = (slug) => axios.get(`${getWorkspaceId()}/number-pools/${slug}/traffic-source`)
const attachTrafficSourceToPool = (slug, formData) => axios.patch(`${getWorkspaceId()}/number-pools/${slug}/traffic-source`, formData)
const detachTrafficSourceFromPool = (slug, traffic_sources) => axios.delete(`${getWorkspaceId()}/number-pools/${slug}/traffic-source`, { data: { traffic_sources } })
const updateTrafficSourcePool = (slug, formData) => axios.put(`${getWorkspaceId()}/number-pools/${slug}/traffic-source`, formData)

const getJsCodeForManager = ({ slug }) => axios.get(`${getWorkspaceId()}/number-pools/${slug}/integration-codes`)
const getJsCodeForVendor = ({ slug }) => axios.get(`${getWorkspaceId()}/vendor/number-pools/${slug}/integration-codes`)
const getParametersUrlForManager = ({ slug }) => axios.get(`${getWorkspaceId()}/number-pools/${slug}/manual-upload-parameters-url`)
const getParametersUrlForVendor = ({ slug }) => axios.get(`${getWorkspaceId()}/vendor/number-pools/${slug}/manual-upload-parameters-url`)
const downloadDNIIntegrationFileForManager = ({ slug }) => axios.get(`${getWorkspaceId()}/number-pools/${slug}/integration-file`)
const downloadDNIIntegrationFileForVendor = ({ slug }) => axios.get(`${getWorkspaceId()}/vendor/number-pools/${slug}/integration-file`)

const attachNumbersToPool = ({ slug, formData }) => axios.patch(`${getWorkspaceId()}/number-pools/${slug}/attach-numbers`, formData)
const buyAndAttachNumbersToPool = ({ slug, formData }) => axios.post(`${getWorkspaceId()}/number-pools/${slug}/phone-numbers`, formData)
const detachNumbersToPool = ({ data, slug }) => axios.delete(`${getWorkspaceId()}/number-pools/${slug}/detach-numbers`, { data })

const updateNumberPoolStatus = (formData) => axios.patch(`${getWorkspaceId()}/number-pools/status`, formData)

const getPoolFiltersAndSorting = () => axios.get(`${getWorkspaceId()}/number-pools/filters-and-sorting`)

export {
    getPoolsAll,
    getAvailableNumbersForPool,
    getPoolsForManager,
    getPoolsForVendor,
    createPool,
    updatePool,
    deletePool,
    autoBuyPool,
    detachPool,
    getDetailPool,
    getJsCodeForManager,
    getJsCodeForVendor,
    getParametersUrlForManager,
    getParametersUrlForVendor,
    attachNumbersToPool,
    detachNumbersToPool,
    buyAndAttachNumbersToPool,
    getPoolFiltersAndSorting,
    downloadDNIIntegrationFileForManager,
    downloadDNIIntegrationFileForVendor,
    getAvailableTrafficSources,
    attachTrafficSourceToPool,
    detachTrafficSourceFromPool,
    updateNumberPoolStatus,
    updateTrafficSourcePool,
}
